<template>
    <transition name="trs-simple-fade">
        <div class="cookie-banner grid grid__base" v-if="!hasUserAccepted">
            <div class="grid--container">
                <div class="cookie-banner--row grid--row">
                    <div class="cookie-banner--message-col grid--col">
                        <h1 class="u-reset u-reset__h2">{{ title }}</h1>
                        <p>
                            {{ text }}
                            <a class="cookie-banner--inline-link" :href="link.path">{{ link.label }}</a>
                        </p>
                    </div>

                    <div class="grid--col cookie-banner--actions cookie-banner--actions-col ">
                        <slot name="actions">
                            <button class="btn btn__small btn__outline" @click="onConfirm">
                                {{ confirm_label }}
                            </button>
                        </slot>
                    </div>
                </div>
            </div>
        </div>
    </transition>
</template>

<script>
    import { readCookie, writeCookie } from 'util/dom/cookie';
    import cmsPartial from 'vue/mixins/cms/cms-partial';

    export default {
        mixins: [
            cmsPartial,
        ],
        props: {
            title: {
                type: String,
                required: true,
            },
            text: {
                type: String,
                required: true,
            },
            link: {
                type: Object,
                required: true,
            },
            confirm_label: { // eslint-disable-line camelcase
                type: String,
                default: 'Ok',
            },
            cookieName: {
                type: String,
                default: 'cookies_accepted',
            },
        },
        data() {
            return {
                hasUserAccepted: Boolean(readCookie(this.cookieName)),
            };
        },
        methods: {
            /**
             * Called when confirming the cookie
             */
            onConfirm() {
                writeCookie({ key: this.cookieName, value: true });
                this.hasUserAccepted = true;
            },
        },
    };
</script>



// WEBPACK FOOTER //
// index.vue?68e2efcc